import { Box } from '@mui/material';
import { ArtifactTemplateCard } from './ArtifactTemplateCard';
import { ArtifactTemplate } from './artifactTemplatesData';

interface ArtifactTemplateCardGridProps {
  templates: ArtifactTemplate[];
  onCardClick: (template: ArtifactTemplate) => void;
}

export const ArtifactTemplateCardGrid = ({
  templates,
  onCardClick,
}: ArtifactTemplateCardGridProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
        gap: 3,
        width: '100%',
      }}
    >
      {templates.map((template) => (
        <ArtifactTemplateCard
          key={template.id}
          template={template}
          onClick={() => onCardClick(template)}
        />
      ))}
    </Box>
  );
};
